import { render } from "./quit.vue?vue&type=template&id=4ba7f0ef&ts=true"
import script from "./quit.vue?vue&type=script&lang=ts"
export * from "./quit.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__